import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import styles from './Button.scss';

// eslint-disable-next-line no-underscore-dangle
const _type = {
  type: ['primary', 'danger'],
};
const regTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
const isTwoCNChar = regTwoCNChar::regTwoCNChar.test;

export default class Button extends Component {
  static propTypes = {
    type: PropTypes.oneOf(_type.type),
    htmlType: PropTypes.string,
    className: PropTypes.string,
    strong: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    strong: false,
  };

  static __Button__ = true;

  constructor(props) {
    super(props);
    this.state = { clicked: false };
  }

  componentWillUnmount() {
    if (this.addClicked) {
      clearTimeout(this.addClicked);
      this.addClicked = null;
    }
    if (this.removeClicked) {
      clearTimeout(this.removeClicked);
      this.removeClicked = null;
    }
  }

  getChildren = () => {
    const { children } = this.props;
    return React.Children.map(children, (child) => {
      // 如果是两个中文，则自动插入空格
      if (_.isString(child) && isTwoCNChar(child)) {
        return (<span>{child.split('').join(' ')}</span>);
      }
      if (_.isString(child)) {
        return (<span>{child}</span>);
      }
      return child;
    });
  };

  clickBtn = (e) => {
    this.setState({ clicked: false });
    // 先clear，再remove
    if (this.removeClicked) {
      clearTimeout(this.removeClicked);
    }

    this.addClicked = setTimeout(() => {
      this.setState({ clicked: true });
    }, 10);
    this.removeClicked = setTimeout(() => {
      this.setState({ clicked: false });
    }, 500);
    if (_.isFunction(this.props.onClick)) {
      this.props.onClick(e);
    }
  };

  blurBtn = () => {
    // eslint-disable-next-line react/no-find-dom-node
    ReactDOM.findDOMNode(this).blur();
  };

  render() {
    const { type, strong, className, htmlType, ...props } = this.props;
    const { clicked } = this.state;

    const btnClass = classNames({
      [`${className}`]: !!className,
      [`${styles['btn']}`]: true,
      [`${styles['btn-strong']}`]: !!strong,
      [`${styles['btn-clicked']}`]: clicked,
      [`${styles[`btn-${type}`]}`]: type && _type.type.includes(type),
    });

    return (
      <button
        {...props}
        type={htmlType || 'button'}
        className={btnClass}
        onClick={this.clickBtn}
        onMouseUp={this.blurBtn}
      >
        {this.getChildren()}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/Button.js